module.exports = __webpack_public_path__ + "assets/ic-blockonomi.f0bbef4a.svg";